/**
 * Badge de nivel del header de la Home: la letra CEFR en un chip circular con
 * borde de gradiente (marco decorativo, NO medidor). Antes usaba `LevelRing`
 * con `LEVEL_PROGRESS_PLACEHOLDER` (un arco fijo al 42% que aparentaba un
 * progreso intra-nivel que no existe en backend y nunca se movía). El arco de
 * progreso vuelve recién cuando exista la métrica real.
 *
 * Al tocarlo abre el `LevelExploreSheet` (plan 38 F3) — explorar otro nivel +
 * link a `/progress`. Si `onOpen` no viene, cae a navegar a `/progress`
 * (defensivo). Muestra un punto lima cuando hay un overlay de exploración activo.
 *
 * Compartido entre HomeMobile (header) y HomeDesktop (slot leading del topbar).
 */
import { useViewNavigate } from '../../../hooks/useViewNavigate.js';
import type { CefrLevel } from '../../../lib/englishApi.js';

interface HeaderLevelRingProps {
  levelId: CefrLevel;
  size?: number;
  /** Abre el sheet de exploración de nivel. Sin esto, navega a `/progress`. */
  onOpen?: () => void;
  /** Hay un overlay de exploración activo → marca visual (punto lima). */
  exploring?: boolean;
}

export function HeaderLevelRing({ levelId, size = 46, onOpen, exploring = false }: HeaderLevelRingProps) {
  const navigate = useViewNavigate();
  return (
    <button
      type="button"
      className={`home-ring-btn${exploring ? ' is-exploring' : ''}`}
      onClick={onOpen ?? (() => void navigate('/progress'))}
      aria-label={exploring ? 'Estás explorando otro nivel — abrir opciones de nivel' : 'Nivel de inglés — explorar o ver evolución'}
    >
      <span
        className="home-level-badge"
        style={{ width: size, height: size, fontSize: Math.round(size * 0.3) }}
      >
        {levelId}
      </span>
      {exploring && <span className="home-ring-explore-dot" aria-hidden="true" />}
    </button>
  );
}
